import update from 'immutability-helper';
import createReducer from '../../../../../common/utils/createReducer.js';
import { types } from '../actions/actionTypes.js';

const initialState = {
  config: {},
  discovery: {},
  aiInsightsLoading: false
};

const reducer = {
  [types.RESET_AI_INSIGHTS]: () => initialState,

  [types.SET_DISCOVERY]: (state, action) => {
    return update(state, {
      discovery: {
        widgetList: { $set: action.payload }
      }
    });
  },

  [types.SAVE_WIDGET_CHART_DATA]: (state, action) => {
    const { widgetId, metricType, chartData, currentLevel } = action.payload;

    return update(state, {
      discovery: {
        $apply: discovery => ({
          ...discovery,
          [widgetId]: {
            ...(discovery?.[widgetId] || {}),
            chartData: {
              ...(discovery?.[widgetId]?.chartData || {}),
              [metricType]: {
                ...(discovery?.[widgetId]?.chartData?.[metricType] || {}),
                [currentLevel]: chartData
              }
            }
          }
        })
      }
    });
  },

  [types.SAVE_WIDGET_TABLE_DATA]: (state, action) => {
    const { widgetId, tableData, cacheKey, metricType, tableColumns, totalRecords } = action.payload;

    return update(state, {
      discovery: {
        $apply: discovery => ({
          ...discovery,
          [widgetId]: {
            ...(discovery?.[widgetId] || {}),
            tableData: {
              ...(discovery?.[widgetId]?.tableData || {}),
              [metricType]: {
                ...(discovery?.[widgetId]?.tableData?.[metricType] || {}),
                [cacheKey]: { data: [...(discovery?.[widgetId]?.tableData?.[cacheKey] || []), ...tableData] },
                ...(tableColumns ? { columns: tableColumns } : {}),
                ...(totalRecords ? { totalRecords: totalRecords } : {})
              }
            }
          }
        })
      }
    });
  },

  [types.SET_WIDGET_CURRENT_LEVEL]: (state, action) => {
    const { widgetId, currentLevel } = action.payload;
    return update(state, {
      discovery: {
        $apply: discovery => ({
          ...discovery,
          [widgetId]: {
            ...(discovery?.[widgetId] || {}),
            currentLevel
          }
        })
      }
    });
  },

  [types.SET_AI_INSIGHTS_LOADING]: (state, action) => {
    return update(state, {
      aiInsightsLoading: { $set: action.payload.loading }
    });
  }
};

export default createReducer(initialState, reducer);
